var v1='<div><div id=TestkitActivationApp></div></div>';
angular.module('account.templates').run(['$templateCache', function ($templateCache) {$templateCache.put('src/app/test-results/test-results-list.html', v1);}]);
module.exports=v1